/* istanbul ignore file */
import parseQuery from './parse-query';
import parseUrl from './parse-url';

export default { parseQuery, parseUrl };
